"use strict";

define('controller/meeting/submission',['underscore', 'moment', 'langs', 'appkit/region.controller', './list', 'config', 'model/meeting', 'model/meeting.document', 'model/meeting.person', 'model/document', 'model/person', 'collection/assignments', 'libs/route.helper', 'libs/loader.helper', 'libs/bind.helper', 'view/calendar.view', 'view/meeting.summary', 'view/table.ellipsis', 'view/table.card', 'view/table.selected.add', 'uikit/uikit', 'libs/format/date', 'libs/format/bold', 'layout/sidebar.layout'], function (_, moment, langs, RegionController, MeetingListController, config, Meeting, MeetingDocument, MeetingPerson, Document, Person, Assignments, RouteHelper, LoaderHelper, BindHelper, CalendarView, MeetingSummary, TableEllipsis, TableCard, TableSelectedAdd, UIKit, dateFormatter, boldFormatter, SidebarLayout) {
  var ContainerView = UIKit.Container;
  var TextView = UIKit.Text;
  var TableView = UIKit.Table;
  var Calendar = UIKit.Calendar;
  var PopupView = UIKit.Popup;
  var ButtonView = UIKit.Button;
  var DimmerView = UIKit.Dimmer;
  var LoaderView = UIKit.Loader;
  var BreadcrumbView = UIKit.Breadcrumb;
  var MenuView = UIKit.Menu;
  var p = langs.phrase;
  var DISABLE_MEETING_NAVIGATE = 'DISABLE_MEETING_NAVIGATE';
  var MeetingSubmissionController = RegionController.extend({
    onStart: function onStart() {
      var app = this.app,
        region = this.region,
        state = this.state,
        self = this;
      var root = new ContainerView(),
        layout = new SidebarLayout(),
        sideView = new ContainerView({}),
        documentId = Number(state.get('documentId')),
        doc = new Document({
          id: documentId
        }),
        calendarMeetings = Meeting.collectionByBoardId(),
        assignments = Assignments.collectionByAssignmentType().params({
          entityType: 'document',
          entityId: documentId,
          assignmentType: 'IRB_BOARD'
        }),
        docRoute = new RouteHelper('submission:detail').add(doc, {
          studyId: 'studyId',
          documentId: 'id'
        }),
        meetings = Meeting.collectionByDocumentId(documentId),
        loaderHelper = new LoaderHelper([meetings]),
        meetingPopup = null,
        calendar = null,
        calendarWeek = null,
        table = new TableView();
      this.meetings = meetings;
      this.loaderHelper = loaderHelper;
      this.documentId = documentId;
      state.set(DISABLE_MEETING_NAVIGATE, true);
      function generateMeetingLink(meetingModel) {
        return RouteHelper.createLink('meeting:detail', meetingModel, {
          meetingId: 'id',
          documentId: documentId
        });
      }
      ;
      function onMeetingAction(meeting, child, actionModel) {
        switch (actionModel.get('action')) {
          case 'destroy':
            self.removeMeeting(meeting);
            break;
        }
      }
      ;
      function tableEllipsisOptions(column, index) {
        var model = this.model;
        return {
          childBindings: {
            text: 'text',
            icon: 'icon',
            link: 'link'
          },
          collection: new Backbone.Collection([{
            text: 'View',
            icon: 'eye',
            link: generateMeetingLink(model)
          }, {
            text: 'Remove',
            icon: 'remove',
            action: 'destroy'
          }])
        };
      }
      ;
      table.collection = meetings;
      table.headless = true;
      table.selectable = true;
      table.basic = true;
      table.borderless = true;
      table.selection = TableView.SINGLE_SELECTION;
      table.emptyText = 'No Assigned Meetings';
      table.columns.set([{
        childView: TableEllipsis,
        childViewOptions: tableEllipsisOptions,
        collapsing: true
      }, {
        data: 'startDate',
        formatter: dateFormatter('L | LT')
      }, {
        data: 'board.name',
        formatter: boldFormatter
      }]);
      table.on('row:before:add:child', function (row, view) {
        if (view instanceof TableEllipsis) {
          view.on('action', _.partial(onMeetingAction, row.model));
        }
      }).on('row:double:press', function (row) {
        app.navigate(generateMeetingLink(row.model).slice(1), {
          trigger: true
        });
      }).listenTo(state, 'change:meeting', function () {
        meetings.fetch();
        calendar.collection.fetch();
      }).listenTo(state, 'meeting:popup', function (mp) {
        var enabledOptions = {
            icon: 'plus',
            text: 'Add',
            color: 'primary',
            fluid: true
          },
          disabledOptions = {
            icon: 'remove',
            text: 'Remove',
            color: 'negative',
            fluid: true
          };
        meetingPopup = mp;
        self.meetingPopup = mp;
        meetingPopup.content.more.destroy();
        meetingPopup.content.more = new ButtonView(enabledOptions).on('press', function () {
          var meeting = state.get('tab') == 'week' ? calendarWeek.value : calendar.selectedAppointment;
          self.toggleMeeting(meeting);
        });
        function updateAddButton() {
          var meeting = this.model;
          if (self.isMeetingLinkedToSubmission(meeting)) {
            _.extend(this, disabledOptions);
          } else {
            _.extend(this, enabledOptions);
          }
        }
        ;
        meetingPopup.content.more.on('change:model', function (view, newModel, prev) {
          if (prev) {
            this.stopListening(prev);
          }
          if (!this.model) {
            return;
          }
          updateAddButton.call(this);
          this.listenTo(this.model, 'change', updateAddButton);
        }).listenTo(meetings, 'sync', updateAddButton);
      }).listenTo(state, 'init:calendar', function (view) {
        calendar = view;
        calendar.childBindings.disabled = 'locked';
      }).listenTo(state, 'init:calendarWeek', function (view) {
        calendarWeek = view;
        calendarWeek.childBindings.disabled = 'locked';
      }).listenTo(state, 'init:addMeeting', function (view) {
        view.color = 'secondary';
      }).listenToOnce(assignments, 'sync', function () {
        var assignment = assignments.at(0);
        if (assignment) {
          state.set('boardId', assignment.get('group').id);
        }
        new MeetingListController(app, layout.main, state).start();
        layout.main.currentView.$el.css('padding', '0');
        layout.main.currentView.off('calendarList:before:add:child').on('calendarList:before:add:child', function (cardList, card) {
          if (card instanceof TableCard) {
            self.configureCalendarListTable(card.table);
          }
        });
      });
      root.add(layout);
      sideView.add(new ContainerView({
        className: 'computer only'
      })).add(new ContainerView({
        attributes: {
          style: 'margin-bottom: 3em;'
        }
      }).add(new TextView({
        className: 'ui header',
        text: 'Assigned Meetings',
        tagName: 'h3'
      }))).add(new ContainerView({
        className: 'ui segment',
        attributes: {
          style: 'padding: 0;'
        }
      }).add(new LoaderView({
        size: 'small',
        model: loaderHelper,
        bindings: {
          active: 'loading'
        }
      })).add(table));
      region.show(root, {
        buttonType: 'done'
      });
      layout.sidebar.show(sideView);
      state.addPageDependencies([assignments, meetings, doc]);
      assignments.fetch();
      meetings.fetch();
      doc.fetch();
    },
    configureCalendarListTable: function configureCalendarListTable(table) {
      var self = this;
      table.columns.unshift({
        childView: TableSelectedAdd,
        collapsing: true,
        onBeforeAdd: function onBeforeAdd(view, meeting) {
          var button = view.view;
          button.model = meeting;
          self.configureTableAddRemoveButton(button);
        }
      });
      table.childBindings.disabled = 'locked';
      table.on('row:add', function (row, view) {
        var button = view.view;
        this.toggleMeeting(row.model);
      }, this);
    },
    configureTableAddRemoveButton: function configureTableAddRemoveButton(button) {
      var meetings = this.meetings;
      button.bindings.disabled = 'locked';
      function syncButtonIcon() {
        if (meetings.get(button.model)) {
          button.icon = 'minus';
        } else {
          button.icon = 'add';
        }
      }
      button.listenTo(meetings, 'add remove', _.debounce(syncButtonIcon));
      syncButtonIcon();
    },
    isMeetingLinkedToSubmission: function isMeetingLinkedToSubmission(meeting) {
      return this.meetings.get(meeting);
    },
    toggleMeeting: function toggleMeeting(meeting) {
      if (meeting) {
        if (this.meetings.get(meeting)) {
          this.removeMeeting(meeting);
        } else {
          this.addMeeting(meeting);
        }
      }
    },
    addMeeting: function addMeeting(meeting) {
      return meeting.fetch().promise().bind(this).then(function () {
        meeting.addDocument({
          id: this.documentId
        });
        meeting.addCurrentDoc(this.documentId);
        this.saveMeeting(meeting);
      });
    },
    removeMeeting: function removeMeeting(meeting) {
      return meeting.fetch().promise().bind(this).then(function () {
        var docs = meeting.get('documents');
        meeting.removeDocument(docs.get(this.documentId));
        meeting.addCurrentDoc(this.documentId);
        this.saveMeeting(meeting);
      });
    },
    saveMeeting: function saveMeeting(meeting) {
      this.loaderHelper.set('loading', true);
      this.meetingPopup.content.more.loading = true;
      return meeting.save().promise().bind(this).then(function () {
        this.state.trigger('change:meeting');
      }).lastly(function () {
        this.loaderHelper.set('loading', false);
        this.meetingPopup.content.more.loading = false;
      });
    }
  });
  return MeetingSubmissionController;
});

